//Parroquia Bolivar
const munCaroniCiudad = [
  'Cachamay',
  'Chirica',
  'Dalla Costa',
  'Once De Abril',
  'Simón Bolívar',
  'Unare',
  'Universidad',
  'Vista Al Sol',
  'Pozo Verde',
  'Yocoima',
  'Cinco de Julio',
];
const munCedeno = [
  'Capital Cedeño',
  'Altagracia',
  'Ascención Ferreras',
  'Guaniamo',
  'La Urbana',
  'Los Pijiguaos',
];
const munElCallao = ['Capital El Callao'];
const munGranSabana = ['Gran Sabana', 'Ikabarú'];
const munHeres = [
  'Agua Salada',
  'Catedral',
  'José Antonio Páez ',
  'La Sabanita',
  'Marhuanta',
  'Vista Hermosa',
  'Orinoco',
  'Panapana',
  'Zea',
];
const munPiar = ['Piar', 'Andrés Eloy Blanco', 'Pedro Cova'];
const munBolivarianoAngostura = [
  'Capital Angostura',
  'Barceloneta',
  'San Francisco',
  'Santa Bárbara',
];

const munRoscio = ['Roscio', 'Salom'];
const munSifontes = ['Sifontes', 'Dalla Costa', 'San Isidro '];
const munSucreBolivar = [
  'Capital Sucre',
  'CasesArchivedPageComponent',
  'Guarataro',
  'Las Majadas',
  'Moitaco ',
];
const munPadrePedroChien = ['Padre Pedro Chien'];

export const esBolivar = [
  {
    municipio: 'Caroní',
    parroquias: munCaroniCiudad,
  },
  {
    municipio: 'Cedeño',
    parroquias: munCedeno,
  },
  {
    municipio: 'El Callao',
    parroquias: munElCallao,
  },
  {
    municipio: 'Gran Sabana',
    parroquias: munGranSabana,
  },
  {
    municipio: 'Heres',
    parroquias: munHeres,
  },
  {
    municipio: 'Piar',
    parroquias: munPiar,
  },
  {
    municipio: 'Bolivariano Angostura',
    parroquias: munBolivarianoAngostura,
  },
  {
    municipio: 'Roscio',
    parroquias: munRoscio,
  },
  {
    municipio: 'Sifontes',
    parroquias: munSifontes,
  },
  {
    municipio: 'Sucre',
    parroquias: munSucreBolivar,
  },
  {
    municipio: 'Padre Pedro Chien',
    parroquias: munPadrePedroChien,
  },
];
